import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useAuth } from "../AuthContext";
import axios from "axios";
import iziToast from "izitoast";
import Footer from "./Footer";

export const ViewTest = () => {
    const { apipath, filepath, logout, goBack } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const tId = localStorage.getItem('tId');
    const [questionsData, setQuestionsData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [testData, setTestData] = useState([]);
    const [totalQuestions, setTotalQuestions] = useState(0);
    const [imgpath, setImgpath] = useState("");
    const [formData, setFormData] = useState({
        test: '',
        subject: '',
        language: 'english',
        description: '',
        question: '',
        question_image: null,
        option1: '',
        option1_image: null,
        option2: '',
        option2_image: null,
        option3: '',
        option3_image: null,
        option4: '',
        option4_image: null,
        answer: '',
        marks: 0,
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleFileChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.files[0] });
    };

    const subjects = Object.keys(questionsData);
    const [selectedSubject, setSelectedSubject] = useState("");

    const getTest = async () => {
        try {
            const response = await axios.post(
                apipath + '/viewTest',
                { id: tId },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            // console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            // console.log(response.data);
            const result = response.data;
            const ques = result.questions;
            const subjs = Object.keys(ques);
            setSelectedSubject(subjs[0]);
            setQuestionsData(ques);
            setTotalQuestions(result.totalQuestions);
            setTestData(result.test);
            setImgpath(filepath + "/public/questionImages_" + result.test?.id + "/");
            // setFilteredData(result.tests);
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {

        }
    }
    useEffect(() => {
        getTest();
    }, []);

    const [activeTab, setActiveTab] = useState("Test");

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [questionStatus, setQuestionStatus] = useState({}); // To track statuses of questions
    const [selectedAnswers, setSelectedAnswers] = useState(JSON.parse(localStorage.getItem('answers')) || {}); // To track selected options

    const questions = questionsData[selectedSubject] || [];
    const currentQuestion = questions[currentQuestionIndex] || null;

    useEffect(() => {
        setFormData(currentQuestion);
    }, [currentQuestion]);

    useEffect(() => {
        console.log(formData);
    }, [formData]);

    const handleSubjectChange = (subject) => {
        setSelectedSubject(subject);
        setCurrentQuestionIndex(0); // Show the first question of the selected subject
        // console.log(formData);
    };

    const handleUpdate = async () => {
        // console.log(formData);
        setIsLoading(true);
        if (formData.marks <= 0) {
            iziToast.error({
                'message': 'Enter valid marks for the question.',
                'position': 'topCenter'
            });
            setIsLoading(false);
            return false;
        }
        try {
            const response = await axios.post(
                apipath + '/update_question', formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            // console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            else if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
                getTest();
            }
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }
        }
        finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async () => {
        // console.log(formData);
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/delete_question', { 'qid': formData.qid, 'test': formData.test },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            // console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            else if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            else {
                iziToast.success({
                    message: response.data.message,
                    position: "topCenter"
                });
                getTest();
            }
        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }
        }
        finally {
            setIsLoading(false);
        }
    };

    const confirmDeletion = () => {
        iziToast.show({
            color: 'red',
            message: 'Confirm Deletion',
            position: 'topCenter', // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter
            buttons: [
                [
                    '<button>Ok</button>',
                    function (instance, toast) {
                        handleDelete();
                        instance.hide({
                            transitionOut: 'fadeOutUp'
                        }, toast);
                    }
                ],
                [
                    '<button>Close</button>',
                    function (instance, toast) {
                        instance.hide({
                            transitionOut: 'fadeOutUp'
                        }, toast);
                    }
                ]
            ]
        });
    }

    return (
        <>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>
                Loading...
            </span>
            {<Navbar />}
            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"tests"} />}
                <div class="main-content flex-1 bg-gray-100 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div class="bg-teal-700 pt-4">
                        <div class="rounded-tl-3xl bg-teal-600 p-2 justify-between shadow text-2xl text-white flex flex-col md:flex-row relative">
                            <span class="font-bold pl-2">
                            <i className="fa fa-arrow-left text-sm border-2 rounded absolute right-3 py-1 px-2 top-2 bg-teal-700 hover:bg-teal-800 cursor-pointer" title="go back" onClick={()=>goBack()}></i>Tests</span>
                            {/* <div className="flex flex-row mt-4 md:mt-0">
                                <Link to={`/exams`}><span class={`md:ml-5 ml-2 ${activeTab === 'Exam' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Exams
                                </span></Link>
                                <Link to={`/tests`}><span class={`md:ml-5 ml-2 ${activeTab === 'Test' ? 'bg-teal-800 border-transparent' : 'bg-transparent border-white'} hover:bg-teal-900 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Tests
                                </span></Link>
                            </div> */}
                        </div>
                    </div>

                    <div class="flex flex-wrap">
                        <div class="w-full">
                            <div className="fluid mx-auto p-4 flex flex-col flex-grow">
                                {/* Subject Selector as Buttons */}
                                <div className="flex flex-wrap justify-between">
                                    <div className="mb-4 flex flex-wrap space-x-4">
                                        <button className="font-medium">Subjects : </button>
                                        {Object.keys(questionsData).map((subject) => (
                                            <button
                                                key={subject}
                                                onClick={() => handleSubjectChange(subject)}
                                                className={`px-2 py-1 rounded border border-teal-500 hover:bg-teal-500 hover:text-white ${selectedSubject === subject ? 'bg-teal-500 text-white' : 'bg-white'
                                                    }`}
                                            >
                                                {subject}
                                            </button>
                                        ))}
                                    </div>
                                    <div>
                                        <button className="font-medium">Marks : {testData.marks_added}/{testData.marks}</button>
                                    </div>
                                </div>

                                <div className="flex flex-row">
                                    {/* Question Display */}
                                    {(currentQuestion && formData) ? <>
                                        <div className="w-3/4 py-2 px-4 border rounded shadow-md bg-white">

                                            <div className="flex flex-col gap-4 h-[60vh] overflow-auto">
                                                <div>
                                                    <label className="block font-medium">Select Subject</label>
                                                    <select
                                                        name="subject"
                                                        onChange={handleChange}
                                                        className="w-full border px-3 py-2 rounded focus:outline-none"
                                                    >
                                                        <option value="">Select Subject</option>
                                                        {/* Add subject options here */}
                                                        {subjects.map((sub) => (
                                                            <>
                                                                <option selected={(formData.subject === sub)} value={sub}>{sub}</option>
                                                            </>
                                                        ))}
                                                    </select>
                                                </div>

                                                {/* Select Language */}
                                                <div>
                                                    <label className="block font-medium">Select Language</label>
                                                    <select
                                                        name="language"
                                                        value={formData.language}
                                                        onChange={(e) => {
                                                            // setLanguage(e.target.value);
                                                            handleChange(e);
                                                        }}
                                                        className="w-full border px-3 py-2 rounded focus:outline-none"
                                                    >
                                                        <option value="english">English</option>
                                                        <option value="hindi">Hindi</option>
                                                        <option value="punjabi">Punjabi</option>
                                                        {/* <option value="urdu">Urdu</option> */}
                                                    </select>
                                                </div>
                                                <div className="md:col-span-2">
                                                    <label className="block font-medium">Description</label>
                                                    <textarea
                                                        name="description"
                                                        value={formData.description}
                                                        onChange={handleChange}
                                                        className={`w-full border px-3 py-2 rounded focus:outline-none ${formData.language}`}
                                                    />
                                                </div>
                                                {/* Question Text */}
                                                <div className="md:col-span-2">
                                                    <label className="block font-medium">Question</label>
                                                    <textarea
                                                        name="question"
                                                        value={formData.question}
                                                        onChange={handleChange}
                                                        className={`w-full border px-3 py-2 rounded focus:outline-none ${formData.language}`}
                                                    />
                                                </div>
                                                {/* Question Image */}
                                                <div className="md:col-span-2">
                                                    <label className="block font-medium">Question Image</label>
                                                    {formData.question_image ? <>
                                                        <img
                                                            src={imgpath + formData.question_image}
                                                            alt="Question"
                                                            className="w-96 mb-4"
                                                        />
                                                    </> : ""}
                                                    <input
                                                        type="file"
                                                        name="question_image"
                                                        onChange={handleFileChange}
                                                        className="w-full border px-3 py-2 rounded focus:outline-none"
                                                    />
                                                </div>

                                                {/* Option 1 Image */}
                                                <div>
                                                    <label className="block font-medium">Option 1 Image</label>
                                                    {formData.option1_image ? <>
                                                        <img
                                                            src={imgpath + formData.option1_image}
                                                            alt="Question"
                                                            className="w-48 mb-4"
                                                        />
                                                    </> : ""}
                                                    <input
                                                        type="file"
                                                        name="option1_image"
                                                        onChange={handleFileChange}
                                                        className="w-full border px-3 py-2 rounded focus:outline-none"
                                                    />
                                                </div>

                                                {/* Option 1 */}
                                                <div>
                                                    <label className="block font-medium">Option 1</label>
                                                    <input
                                                        type="text"
                                                        name="option1"
                                                        value={formData.option1}
                                                        onChange={handleChange}
                                                        className={`w-full border px-3 py-2 rounded focus:outline-none ${formData.language}`}
                                                    />
                                                </div>

                                                {/* Option 2 Image */}
                                                <div>
                                                    <label className="block font-medium">Option 2 Image</label>
                                                    {formData.option2_image ? <>
                                                        <img
                                                            src={imgpath + formData.option2_image}
                                                            alt="Question"
                                                            className="w-48 mb-4"
                                                        />
                                                    </> : ""}
                                                    <input
                                                        type="file"
                                                        name="option2_image"
                                                        onChange={handleFileChange}
                                                        className="w-full border px-3 py-2 rounded focus:outline-none"
                                                    />
                                                </div>

                                                {/* Option 2 */}
                                                <div>
                                                    <label className="block font-medium">Option 2</label>
                                                    <input
                                                        type="text"
                                                        name="option2"
                                                        value={formData.option2}
                                                        onChange={handleChange}
                                                        className={`w-full border px-3 py-2 rounded focus:outline-none ${formData.language}`}
                                                    />
                                                </div>

                                                {/* Option 3 Image */}
                                                <div>
                                                    <label className="block font-medium">Option 3 Image</label>
                                                    {formData.option3_image ? <>
                                                        <img
                                                            src={imgpath + formData.option3_image}
                                                            alt="Question"
                                                            className="w-48 mb-4"
                                                        />
                                                    </> : ""}
                                                    <input
                                                        type="file"
                                                        name="option3_image"
                                                        onChange={handleFileChange}
                                                        className="w-full border px-3 py-2 rounded focus:outline-none"
                                                    />
                                                </div>

                                                {/* Option 3 */}
                                                <div>
                                                    <label className="block font-medium">Option 3</label>
                                                    <input
                                                        type="text"
                                                        name="option3"
                                                        value={formData.option3}
                                                        onChange={handleChange}
                                                        className={`w-full border px-3 py-2 rounded focus:outline-none ${formData.language}`}
                                                    />
                                                </div>

                                                {/* Option 4 Image */}
                                                <div>
                                                    <label className="block font-medium">Option 4 Image</label>
                                                    {formData.option4_image ? <>
                                                        <img
                                                            src={imgpath + formData.option4_image}
                                                            alt="Question"
                                                            className="w-48 mb-4"
                                                        />
                                                    </> : ""}
                                                    <input
                                                        type="file"
                                                        name="option4_image"
                                                        onChange={handleFileChange}
                                                        className="w-full border px-3 py-2 rounded focus:outline-none"
                                                    />
                                                </div>

                                                {/* Option 4 */}
                                                <div>
                                                    <label className="block font-medium">Option 4</label>
                                                    <input
                                                        type="text"
                                                        name="option4"
                                                        value={formData.option4}
                                                        onChange={handleChange}
                                                        className={`w-full border px-3 py-2 rounded focus:outline-none ${formData.language}`}
                                                    />
                                                </div>

                                                {/* Correct Answer */}
                                                <div className="md:col-span-2">
                                                    <label className="block font-medium">Correct Answer</label>
                                                    <select
                                                        name="answer"
                                                        value={formData.answer}
                                                        onChange={handleChange}
                                                        className="w-full border px-3 py-2 rounded focus:outline-none"
                                                    >
                                                        <option value="">Select Correct Answer</option>
                                                        <option value="a">Option 1</option>
                                                        <option value="b">Option 2</option>
                                                        <option value="c">Option 3</option>
                                                        <option value="d">Option 4</option>
                                                    </select>
                                                </div>
                                                <div>
                                                    <label className="block font-medium">Marks</label>
                                                    <input
                                                        type="number"
                                                        name="marks"
                                                        value={formData.marks}
                                                        onChange={handleChange}
                                                        className="w-full border px-3 py-2 rounded focus:outline-none"
                                                    />
                                                </div>
                                            </div>

                                            {/* Action Buttons */}
                                            <div className="mt-4 flex space-x-4 justify-end">
                                                {/* <button onClick={handlePrevious} className="px-4 py-2 bg-gray-300 rounded">
                                                    Update
                                                </button>
                                                <button onClick={handleNext} className="px-4 py-2 bg-gray-300 rounded">
                                                    Delete
                                                </button> */}
                                                <button onClick={handleUpdate} className="px-4 py-1 bg-teal-500 text-white rounded">
                                                    Update
                                                </button>
                                                <button onClick={confirmDeletion} className="px-4 py-1 bg-red-500 text-white rounded">
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </> : ""}

                                    {/* All Questions Display on the Right */}
                                    <div className="w-1/4 py-2 px-4 flex flex-col bg-white items-center border rounded shadow-md max-h-[69vh]">
                                        <h3 className="text-lg font-bold mb-4">All Questions</h3>
                                        <div className="space-y-1 w-full overflow-auto">
                                            {/* Show all questions in serial order */}
                                            {Object.keys(questionsData).map((subject) => (
                                                <div key={subject}>
                                                    <h4 className="font-normal">{subject}</h4>
                                                    {questionsData[subject].map((ques, index) => (
                                                        <button
                                                            key={ques.id}
                                                            onClick={() => {
                                                                setSelectedSubject(subject);
                                                                setCurrentQuestionIndex(index);
                                                            }}
                                                            className={`p-1 m-px border-2 rounded min-w-7 ${(subject === selectedSubject && index === currentQuestionIndex) ? 'border-teal-700' : ''} bg-white text-black`}
                                                        >
                                                            {ques.id + 1}
                                                        </button>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};